import { render, staticRenderFns } from "./ProductPageApp.vue?vue&type=template&id=15f35bc8&scoped=true"
import script from "./ProductPageApp.vue?vue&type=script&lang=js"
export * from "./ProductPageApp.vue?vue&type=script&lang=js"
import style0 from "./ProductPageApp.vue?vue&type=style&index=0&id=15f35bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f35bc8",
  null
  
)

export default component.exports